import { render } from "./OrganizationNew.vue?vue&type=template&id=f38ec774"
import script from "./OrganizationNew.vue?vue&type=script&lang=js"
export * from "./OrganizationNew.vue?vue&type=script&lang=js"

import "./OrganizationNew.vue?vue&type=style&index=0&id=f38ec774&lang=scss"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__